import React from 'react';
import { AccountCreateForm } from '@components-member/TradingAccounts/AccountCreate/components/AccountCreateForm';
import { ACCOUNT_CREATE_STEP } from '@components-member/TradingAccounts/AccountCreate/interfaces';
import { TRADING_ACCOUNT_FORM_TYPE } from 'global.enums';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';

export interface IAccountCreateFormWrapperProps {
  closeModalHandler: () => void;
  accountType: TRADING_ACCOUNT_FORM_TYPE;
  changeStep: (step: ACCOUNT_CREATE_STEP) => void;
  isBackButtonDisplayed: boolean;
}

export const AccountCreateFormWrapper = observer((props: IAccountCreateFormWrapperProps): JSX.Element => {
  const { closeModalHandler, accountType, changeStep, isBackButtonDisplayed } = props;

  const {
    accountStore: { generalSettings, userProfile, userInfo },
  } = useMobxStore();

  const { canSetIb, ibCodePrefix } = generalSettings;
  const { clientSourceType } = userProfile.profile;

  return (
    <div className={`${accountType.toLowerCase()}--form`}>
      <AccountCreateForm
        canSetIb={canSetIb}
        ibCodePrefix={ibCodePrefix}
        clientSourceType={clientSourceType}
        accountType={accountType}
        user={userInfo}
        closeHandler={closeModalHandler}
        changeStep={changeStep}
        isBackButtonDisplayed={isBackButtonDisplayed}
      />
    </div>
  );
});
